/**
 *  Intl.DateTimeFormat default options
 */
export default { day: '2-digit', month: '2-digit', year: 'numeric' };
